var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "90px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入订单编号",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.orderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderNo", $$v)
                                },
                                expression: "listPram.orderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收件人名" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.receiverName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "receiverName", $$v)
                                },
                                expression: "listPram.receiverName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收件电话" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.receiverPhone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "receiverPhone", $$v)
                                },
                                expression: "listPram.receiverPhone",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.spuName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "spuName", $$v)
                                },
                                expression: "listPram.spuName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.orderType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderType", $$v)
                                },
                                expression: "listPram.orderType",
                              },
                            },
                            _vm._l(_vm.orderTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "status", $$v)
                                },
                                expression: "listPram.status",
                              },
                            },
                            _vm._l(_vm.orderStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "物流状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.deliveryStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "deliveryStatus", $$v)
                                },
                                expression: "listPram.deliveryStatus",
                              },
                            },
                            _vm._l(_vm.deliveryStatusList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "下单时间：" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth ",
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.dataRenage,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "dataRenage", $$v)
                              },
                              expression: "listPram.dataRenage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-center" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:download"],
                          expression: "['admin:order:download']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.exportList2 },
                    },
                    [_vm._v("订单导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.exportOrderSendList },
                    },
                    [_vm._v("发货导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.isExporting,
                        title: "导出中",
                        "show-close": false,
                        "close-on-click-modal": false,
                        "custom-class": "export-dialog",
                        width: "450px",
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.isExporting = $event
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "export-dialog-content" }, [
                        _c("i", {
                          staticClass: "el-icon-download export-icon",
                        }),
                        _vm._v(" "),
                        _c("h3", { staticClass: "export-title" }, [
                          _vm._v("正在导出数据，请稍候..."),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "progress-container" },
                          [
                            _vm.exportProgress < 100
                              ? _c("el-progress", {
                                  attrs: {
                                    percentage: _vm.exportProgress,
                                    "stroke-width": 20,
                                    color: _vm.customColors,
                                    "text-inside": true,
                                  },
                                })
                              : _c("el-progress", {
                                  attrs: {
                                    percentage: 100,
                                    "stroke-width": 20,
                                    color: "#67C23A",
                                    status: "success",
                                    "text-inside": true,
                                  },
                                }),
                            _vm._v(" "),
                            _c("div", { staticClass: "progress-info" }, [
                              _c("span", { staticClass: "status-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.exportProgress < 100
                                      ? "导出处理中..."
                                      : "导出完成！"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "progress-text" }, [
                                _vm._v(_vm._s(_vm.exportProgress) + "%"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                height: "70vh",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单编号",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.orderNo))]),
                        _vm._v(" "),
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.TYPE_COLOR_MAP[scope.row.type],
                            },
                          },
                          [_vm._v(_vm._s(scope.row.typeName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuName",
                  label: "产品名称",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", {
                        domProps: { innerHTML: _vm._s(scope.row.skuName) },
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuCode",
                  label: "产品编码",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", {
                        domProps: { innerHTML: _vm._s(scope.row.skuCode) },
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuAttr",
                  label: "销售属性",
                  "min-width": "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", {
                        domProps: { innerHTML: _vm._s(scope.row.skuAttr) },
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", {
                        domProps: { innerHTML: _vm._s(scope.row.brandName) },
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "订单状态", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("span", {}, [
                        _vm._v(
                          _vm._s(
                            _vm.transformState(
                              _vm.orderStateOption,
                              scope.row.status,
                              "value"
                            )
                          )
                        ),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deliveryStatusName",
                  label: "物流状态",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userRemark",
                  label: "客户备注",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalQuantity",
                  label: "产品数量",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              !_vm.homeType
                ? _c("el-table-column", {
                    attrs: {
                      prop: "totalPrice",
                      label: "订单金额",
                      "min-width": "100",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalSupplierPrice",
                  label: "供货金额",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "receiverName",
                  label: "收件人",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "deliveryNo",
                  label: "物流单号",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "下单时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "shipmentsTime",
                  label: "发货时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:detail"],
                                expression: "['admin:order:detail']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row.orderNo)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        _vm._v(" "),
                        [2, 3, 4, 5, 16].includes(scope.row.status)
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.sendOrder(scope.row.orderNo)
                                  },
                                },
                              },
                              [_vm._v("订单发货")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ImportTransport", {
        ref: "ImportTransportRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("OrderDetail", { ref: "OrderDetailRef" }),
      _vm._v(" "),
      _c("OrderSend", {
        ref: "OrderSendRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("OrderStatusPopup", {
        ref: "orderStatusPopupRefs",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("SendKami", {
        ref: "SendKamiRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }